module.exports = __webpack_public_path__ + "img/16_39.da6a66cc.png";